app.controller(
    'ResetPasswordController', ['$scope', '$rootScope', '$location', 'AuthenticationService', 'FlashService', 'UserService', '$stateParams', '$state', '$translate', 'toastr', ResetPasswordController]
);

function ResetPasswordController($scope, $rootScope, $location, AuthenticationService, FlashService, UserService, $stateParams, $state, $translate, toastr) {
    var vm = this;

    vm.UserToReset = {
        Pwd: '',
        PwdConfirm: ''
    };

    //Password reset
    vm.ShowValidateEmailMessage = false;
    vm.ShowPasswordCreatedMessage = false;
    vm.HasError = false;
    vm.ErrorMessage = '';
    vm.CheckPwd = {};

    if ($stateParams.lang) {
        $scope.CurrentLang = $stateParams.lang;
    }
    else {
        $scope.CurrentLang = 'fr';
    }    
    $translate.use($scope.CurrentLang);

    //ReinitilisationEmail.html
    vm.ValidateEmailForReset = function () {
        vm.ShowValidateEmailMessage = false;
        vm.HasError = false;        
        AuthenticationService.ValidateEmailForReset(vm.UserToReset.Email, $scope.CurrentLang, $translate.instant("ReinitialisationDeMotDePasse"), function (response) {
            vm.ValidateEmailResult = response.data;
            vm.ShowValidateEmailMessage = true;
            toastr.success($translate.instant("NousVousAvonsEnvoyeUnEmailPourReinitialiserVotreMotDePasse"));
        });
    }

    //ReinitialisationPwd.html
    vm.ResetPassword = function () {
        vm.ShowPasswordCreatedMessage = false;
        vm.CheckPwd.HasError = false;        
        vm.CheckPwd = ValidatePassword(vm.UserToReset.Pwd, vm.UserToReset.PwdConfirm, $translate.instant("LesMotsDePasseNeCorrespondentPas"), $translate.instant("VotreMotDePasseDoitAvoirAuMoinsDe8Characteres"));
        if (!vm.CheckPwd.HasError) {
            vm.UserToReset.Guid = $stateParams.guid;
            AuthenticationService.ResetPassword(vm.UserToReset, function (response) {
                if (response.status == 200) {
                    vm.ShowPasswordCreatedMessage = true;
                    toastr.success($translate.instant("VotreMotDePasseAEteReinitialise"));
                } else {
                    vm.CheckPwd.HasError = true;
                    vm.CheckPwd.ErrorMessage = 'Erreur: Votre mot de passe n\'a pas été réinitialisé !';
                }
            });
        }
    }
}

